import { ErrorLocale } from "@/locales/localeid";
import { Result, Button } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { Component, Vue } from "vue-property-decorator";

@Component({
	components: {
		"a-result": Result,
		Button
	}
})
export default class NotFound extends Vue {
	get message() {
		return fmtMsg(ErrorLocale.NotFoundMessage);
	}

	goToHome() {
		window.location.href = "/";
	}
}
